// utils/theme.js
export const colors = {
  primary: "#dd3537",
  background: "#fdf9f7",
  card: "#ffffff",
  text: "#222",
};